import React from 'react'
import { ContractPerformance } from '../../../types'

interface ContractPerformanceStageCountProps {
    contractPerformance: ContractPerformance
    theme: string
}

const STAGE = [
    'Редактирование',
    'Подготовка к размещению',
    'Отправка в ЕИС',
    'Размещенное исполнение',
]

const STAGE_COLOR = new Map([
    ['Редактирование', '#049664'],
    ['Подготовка к размещению', '#049664'],
    ['Отправка в ЕИС', '#049664'],
    ['Размещенное исполнение', '#049664'],
])

const STATUS_COLOR = new Map([
    ['Черновик', '#049664'],
    ['Готово', '#049664'],
    ['Подготовка', '#049664'],
    ['Готово к отправке', '#049664'],
    ['Отправлено в ЕИС', '#049664'],
    ['Размещена', '#049664'],
    ['Недействительно', '#c15c5c'],
])

const PerformanceStage: React.FC<ContractPerformanceStageCountProps> = ({
    contractPerformance,
    theme,
}) => {
    let complete_stage = true
    return (
        <>
            <div className="relative flex flex-row w-[1710px] h-full z-0 bg-[#e5e5e5] dark:bg-[#000000]">
                <svg className="flex absolute w-full h-full">
                    <line
                        x1="214"
                        y1="45"
                        x2="1503"
                        y2="45"
                        stroke={theme == 'dark' ? '#464447' : '#6A6A6A'}
                        strokeWidth="1"
                        strokeDasharray="5 5"
                    />
                </svg>
                <div className="flex w-full h-full z-20 absolute">
                    {STAGE.map((stage, index) => (
                        <div
                            key={index}
                            className="flex flex-col flex-1 justify-center items-center"
                        >
                            <div
                                className={`flex w-full h-full justify-center items-end ${complete_stage ? (stage == contractPerformance?.performance_stage ? 'text-[12.8px] text-[#181818] dark:text-[#FFFFFF] ' : 'text-[10px] text-[#181818] dark:text-[#FFFFFF] ') : ' text-[10px] text-[#6A6A6A] dark:text-[#8A8A8A]'}`}
                            >
                                {stage}
                            </div>
                            <div className="flex w-full h-full justify-center items-center">
                                <svg width="24" height="24">
                                    {complete_stage ? (
                                        <>
                                            <circle
                                                cx="12"
                                                cy="12"
                                                r="6"
                                                fill={`${STAGE_COLOR.get(String(stage))}`}
                                            />
                                            <circle
                                                cx="12"
                                                cy="12"
                                                r="8"
                                                fill="none"
                                                stroke={`${STAGE_COLOR.get(String(stage))}55`}
                                                strokeWidth="5"
                                            />
                                        </>
                                    ) : (
                                        <>
                                            <circle
                                                cx="12"
                                                cy="12"
                                                r="6"
                                                fill={
                                                    theme == 'dark'
                                                        ? '#464447'
                                                        : '#6A6A6A'
                                                }
                                            />
                                        </>
                                    )}
                                </svg>
                            </div>
                            <div
                                className={`flex w-full h-full justify-center items-start ${complete_stage ? 'text-[12.8px] text-[#181818] dark:text-[#FFFFFF] ' : ' text-[10px] text-[#6A6A6A] dark:text-[#8A8A8A]'}`}
                            >
                                {stage == contractPerformance?.performance_stage
                                    ? contractPerformance?.performance_status
                                    : ''}
                            </div>
                            {stage == contractPerformance?.performance_stage
                                ? (complete_stage = false)
                                : ''}
                        </div>
                    ))}
                </div>
            </div>
        </>
    )
}

export default PerformanceStage
